/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./edit-show-title.vue?vue&type=template&id=47132dc2&scoped=true&"
import script from "./edit-show-title.vue?vue&type=script&lang=ts&"
export * from "./edit-show-title.vue?vue&type=script&lang=ts&"
import style0 from "./edit-show-title.vue?vue&type=style&index=0&id=47132dc2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47132dc2",
  null
  
)

export default component.exports